// extracted by mini-css-extract-plugin
export var primitiveLabel = "_ux-0";